import {showErrorNotification, showSuccessNotification} from "../../global/notifications";
import html2pdf from "../../global/html2pdf";

export default function () {
    updateProfitEvent();
    specialFormEvent();
    submitOverride();
    approvalEvent();
    rejectionEvent();
    downloadEvent();
    nbAutocomplete();
}

//Elements
const nbAutocomplete = async () => {
    try {
        const pac = $('.js-nb-autocomplete');
        const pacDs = new kendo.data.DataSource({
            serverFiltering: false,
            transport: {
                read: {
                    type: 'post',
                    url: '/Sales/BondRequests/GetNorthBoundaryOpportunities'
                }
            }
        });
        pacDs.fetch();
        pac.kendoAutoComplete({
            placeholder: 'Search projects...',
            filter: 'contains',
            dataSource: pacDs,
            width: '100%',
            dataTextField : "OpportunityName",
            select(e) {
                $('[name="ProjectValue"]').data('kendoNumericTextBox').value(e.dataItem.Amount);
                $('[name="Description"]').val(e.dataItem.ScopeDescription);
            }
        });
        return true;
    } catch (e) {
        return Promise.reject(e);
    }
};

//Form Functionality
const updateProfitEvent = () => {
    const $triggerElements = $('#ProjectValue, #LaborDollars, #MaterialDollars, #SubcontractorDollars');

    $triggerElements.blur(function () {
        updateProfit();
    })
}
const updateProfit = () => {
    const $projectValue = $('#ProjectValue');
    const $laborDollars = $('#LaborDollars');
    const $materialDollars = $('#MaterialDollars');
    const $subcontractorDollars = $('#SubcontractorDollars');

    if ($projectValue.length && $laborDollars.length && $materialDollars.length && $subcontractorDollars.length) {
        const k_projectValue = $projectValue.data('kendoNumericTextBox');
        const k_laborDollars = $laborDollars.data('kendoNumericTextBox');
        const k_materialDollars = $materialDollars.data('kendoNumericTextBox');
        const k_subcontractorDollars = $subcontractorDollars.data('kendoNumericTextBox');

        if (k_projectValue && k_laborDollars && k_materialDollars && k_subcontractorDollars) {
            const projectValue = k_projectValue.value() || 0;
            const laborDollars = k_laborDollars.value() || 0;
            const materialDollars = k_materialDollars.value() || 0;
            const subcontractorDollars = k_subcontractorDollars.value() || 0;

            const profit = projectValue - laborDollars - materialDollars - subcontractorDollars;
            $('.js-profit').text(kendo.format('{0:C2}', profit));
        }
    }
}

const specialFormEvent = () => {
    const $checkbox = $('#SpecialBondForm');
    if ($checkbox.length) {
        $checkbox.click(function () {
            specialFormMessage();
        })
    }
}
const specialFormMessage = () => {
    const $checkbox = $('#SpecialBondForm')
    const $message = $('.js-special-bond-message-text');
    if ($checkbox.length && $checkbox.prop('checked')) {
        $message.show();
    } else {
        $message.hide();
    }
}

//Submission
const checkRequiredFields = (highlightFields = true) => {
    $('.fieldValidationError').removeClass('fieldValidationError');
    const $requiredFields = $('[data-required="True"]');

    let errorsFound = false;

    $.each($requiredFields, function (index, ele) {
        const $ele = $(ele);
        const eVal = $ele.prop('tagName') === 'P' ? $ele.text() : $ele.val();
        if (eVal == null || eVal === '' || eVal === '-1') {
            if(highlightFields) {
                if ($ele.hasClass('k-textbox')) {
                    $ele.addClass('fieldValidationError');
                } else {
                    $ele.parent().addClass('fieldValidationError');
                }
            }
            errorsFound = true;
        }
    });

    if (errorsFound) {
        if(highlightFields) {
            showErrorNotification('Please fill out all required fields.');
        }else{
            showErrorNotification('Please edit form and fill out all required fields.');
        }
    }

    return !errorsFound;

}
const submitOverride = () => {
    const $submitButton = $('.js-submit');

    $submitButton.unbind('click');
    $submitButton.click(function (event) {
        event.preventDefault();
        if (checkRequiredFields()) {
            const $form = $('form');
            $.post('/Sales/BondRequests/SaveBondRequestInfo', $form.serialize(), function(response){
               if(response.success){
                   $form.submit();
               }
            });
        }
    })
}

// Approvals
export const approvalEvent = () => {
    let $approvalButton = $('[data-role="approve"]');
    if ($approvalButton.length) {
        $approvalButton.prop('disabled', false);

        $approvalButton.off('click').click(function() {
            if (!checkRequiredFields(false)) return;
            $approvalButton.prop('disabled', true);
            const $pin = $('[id*="pin_id_"]');
            let data = {
                pin: $pin.val(),
                bondRequestId: $('[name=Id]').val(),
                role: $pin.attr('id').substr(7),
                comment: $('[name="approval_comment"]').val(),
            };

            if (data.pin === '') {
                showErrorNotification('Please Enter Pin');
                $approvalButton.prop('disabled', false);
            } else {
                approveBondRequest(data);
            }
        });
    }
};

export const approveBondRequest = data => {
    const $approvalSection = $('#Approvals');

    if ($approvalSection.length) {
        $approvalSection.load('/Sales/BondRequests/BondRequestApproval', data, function(responseText, textStatus, jqXHR) {
            if (jqXHR?.status === 500 || textStatus === 'error') {
                showErrorNotification('An error occurred while processing your request.');
                approvalEvent();
                rejectionEvent();
                return;
            }

            const $error = $('#approval-error');
            const $isEditable = $('#is-editable');

            if ($isEditable.prop('checked')) {
                $('.form-footer--js').show();
            } else {
                $('.form-footer--js').hide();
            }
            if ($error.length) {
                showErrorNotification($error.val());
            } else {
                showSuccessNotification(data.role === 'reject' ? 'Successfully Rejected!' : 'Successfully Approved!');
            }

            // Reattach Events
            approvalEvent();
            rejectionEvent();
        });
    }
};

// Rejection
export const rejectionEvent = () => {
    const $rejectButton = $('[data-role="reject"],[data-role="remove_unlock"]');
    if ($rejectButton.length) {
        $rejectButton.prop('disabled', false);

        $rejectButton.off('click').click(function() {
            $rejectButton.prop('disabled', true);
            let data = {
                bondRequestId: $('[name=Id]').val(),
                comment: $('[name="approval_comment"]').val(),
                role: $(this).data('role'),
            };

            if ((!data.comment || !data.comment.trim()) && data.role !== 'remove_unlock') {
                showErrorNotification('Please enter Comment to proceed with rejection.');
                $rejectButton.prop('disabled', false);
                return;
            }

            approveBondRequest(data);
        });
    }
};

//PDF Download
const downloadEvent = () => {
    const $downloadButton = $('.js-pdf-download');
    if ($downloadButton.length) {
        $downloadButton.click(downloadPdf);
    }
}

const downloadPdf = () => {
    //disable button
    const $downloadButton = $('.js-pdf-download');
    $downloadButton.prop('disabled', true);

    const bondRequestId = $('[name=Id]').val();
    $.get('/Sales/BondRequests/GetBondRequestReport', {bondRequestId: bondRequestId}, function () {
        $downloadButton.prop('disabled', false);
    });
}

